import { getOpsToken, setOpsImpersonatorToken, getOpsImpersonatorToken } from "../api/client";

export function osAppUrl() {
  const configured = String(process.env.REACT_APP_OS_APP_URL || "").trim();
  if (configured) return configured.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:5173";
  }
  return "https://stiqos-dashboard.fly.dev";
}

export function takeImpersonateTokenFromLocation() {
  if (typeof window === "undefined") return null;
  const hash = window.location.hash || "";
  const hashMatch = hash.match(/^#impersonate=(.+)$/);
  if (hashMatch && hashMatch[1]) {
    const token = decodeURIComponent(hashMatch[1]);
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
    return token;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = (params.get("impersonate") || "").trim();
    if (!fromQuery) return null;
    params.delete("impersonate");
    const qs = params.toString();
    window.history.replaceState(
      null,
      "",
      window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash
    );
    return fromQuery;
  } catch {
    return null;
  }
}

export function impersonationHandoffUrl(appUrl, token) {
  return `${String(appUrl || "").replace(/\/$/, "")}/#impersonate=${encodeURIComponent(token)}`;
}

export function openImpersonationHandoff(appUrl, token) {
  const url = impersonationHandoffUrl(appUrl, token);
  const opened = window.open(url, "_blank", "noopener,noreferrer");
  if (!opened) window.location.assign(url);
}

export function stashCurrentOpsSessionIfNeeded() {
  const current = getOpsToken();
  if (current && !getOpsImpersonatorToken()) setOpsImpersonatorToken(current);
}

export function grantsIncludeApp(grants, app) {
  return Array.isArray(grants) && grants.some((grant) => grant && grant.app === app);
}
